const FacilitiesAmenitiesHeader = ({ title, description }: any) => {
	return (
		<div className="header mb-10 lg:w-[45%] mx-auto px-[0.87rem]">
			<h2 className="text-h5 lg:text-h3 text-black text-center leading-[1] mb-6">
				{title}
			</h2>
			<p className="text-bodyM mx-auto lg:w-[70%] text-oBlack-60 font-national text-center">
				{description}
			</p>
		</div>
	)
}

export default FacilitiesAmenitiesHeader
